import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { Reveal } from "@/components/util/Reveal";
import { usePageSeo } from "@/lib/usePageSeo";
import { Logo } from "@/components/layout/Logo";
import { PresentationKeyGate } from "@/components/presentation/PresentationKeyGate";
import { PresentationSections } from "@/components/presentation/PresentationSections";

const STORE = "ur_pres_qredits_key";

export default function QreditsPresentationPage() {
  usePageSeo({ title: "Ur Designs — Private Presentation", noindex: true });
  const [params, setParams] = useSearchParams();
  const [data, setData] = useState(null);
  const [state, setState] = useState("loading");

  const load = async (key) => {
    if (!key) return setState("locked");
    setState("loading");
    try {
      const r = await api.get("/presentations/qredits", { headers: { "x-presentation-key": key } });
      sessionStorage.setItem(STORE, key);
      setData(r.data);
      setState("ready");
    } catch {
      sessionStorage.removeItem(STORE);
      setState("denied");
    }
  };

  useEffect(() => {
    const urlKey = params.get("key");
    if (urlKey) {
      params.delete("key");
      setParams(params, { replace: true });
    }
    load(urlKey || sessionStorage.getItem(STORE));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div data-testid="qredits-presentation" className="min-h-screen bg-[#0A0A0A] text-white">
      <header className="absolute top-0 inset-x-0 z-20 px-6 sm:px-10 lg:px-16 py-6 flex items-center justify-between">
        <Logo />
        {data && (
          <span data-testid="pres-prepared-for" className="hidden sm:block text-xs font-bold uppercase tracking-[0.2em] text-[#A3A3A3]">
            {data.config.prepared_for}
          </span>
        )}
      </header>
      {state === "ready" && data ? (
        <PresentationSections data={data} />
      ) : (
        <PresentationKeyGate state={state} onSubmit={load} />
      )}
      <Reveal as="footer" className="px-6 sm:px-10 lg:px-16 py-10 border-t border-[#1A1A1A] text-xs text-[#5C5C5C]">
        Confidential proposal · Ur Designs · Aruba
      </Reveal>
    </div>
  );
}
